import React from 'react';
import { makeStyles } from '@material-ui/styles';

import { useState, useRef, useEffect } from 'react'

import strings from './strings/StringsApp'
import FetchLocation from './component/FetchLocation';
import Loading from './component/Loading';
import StorePage from './component/StorePage';
import AddressPage from './component/AddressPage';
import SendPage from './component/SendPage';
import CheckoutPage from './component/CheckoutPage';

import InfoPage from './component/InfoPage';
import PaymentPage from './component/PaymentPage';
import TestPage from './component/TestPage';

import { getStoreData, getTakeOrderVersion } from './hooks/store';
import { getDeliveryFees, getDistance } from './hooks/orders-fees';
import { getIntent } from './hooks/orders-format';
import { ThemeProvider } from '@material-ui/core';
import theme from './theme';
import OpenTicketPage from './component/OpenTicketPage';
import OrderStatus from './component/OrderStatus';
import observeOrder from './hooks/observeOrder';
import { storageRequest } from './hooks/localStorageRequest'
import { pickupDatasource, addressDatasource } from './hooks/localStorage';
import { hasItemServices, removeServices } from './hooks/item-services'
import ItemPage from './component/ItemPage';
import { clientInfosource } from './hooks/client-data'

import { log } from './hooks/debug';
import ClientInfoPage from './component/ClientInfoPage';
import { generateQuickGuid } from './hooks/uid'


const useStyles = makeStyles((theme) => ({
  fatText: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },

  fatButget: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
  fatIcon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    alignItems: 'center',
  },
  fat: {
    justifyContent: 'center',
    margin: theme.spacing(1), // You might not need this now
    position: "fixed",
    bottom: theme.spacing(0.5),
    right: '15%'
  },

  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  content: {
    height: 80
  },

  failure: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(10, 2),
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2, 2),
  },

  failureIcon: {
    margin: theme.spacing(0),
  },
  failureTitle: {
    margin: theme.spacing(2),
  },

}));

const getDefaultOrder = () => {
  return {
    status: "store",
    type: "delivery",
    fullAddress: undefined,
    list: [],
    priceDelivery: undefined,
    textTicket: true
  };
}



const isTimeout = (time) => {
  const timeout = (1000 * 60) * 60 * 3;  // 3 hours 
  const current = new Date().getTime();
  return (current - time > timeout);
}





export default function App() {

  const classes = useStyles();
  const [location, setLocation] = useState(null);
  const [storeData, setStoreData] = useState(null);
  const [progress, setProgress] = useState(true);
  const [status, setStatus] = useState('fetch');

  const order = useRef(getDefaultOrder());
  const [failure, setFailure] = useState(null);
  const [debug, setDebug] = useState(false);
  const [rtStatus, setRtStatus] = useState({
    status: "REQUEST"
  });
  const [item, setItem] = useState(null);


  const resetStore = () => {
    storageRequest.remove()
    order.current = getDefaultOrder();
    setLocation(null);
    setStoreData(null);
    setProgress(true);
    setStatus('fetch');
  }

  const getCurrentClient = (clientInfo) => {
    log.message('App', "getCurrentClien,clientInfo", clientInfo);
    let user = clientInfosource.get(); 
    if (!user || !user.id) {
      user = {
        id: generateQuickGuid(),
      }
      clientInfosource.set(user);
      log.message('App', "New client");
    }

    const client ={
      id: user.id,
    }

    if (clientInfo && clientInfo.name) {
      client.name = user.name ;
    }
    if (clientInfo && clientInfo.phone) {
      client.phone = user.phone;
    }

    log.message('App', "getCurrentClien", client);
    return client;
  }
  /**
  ********************  ON FETCH **************************************************************
  *********************************************************************************************/

  const handlerOnFetch = (response) => {
    log.message('App', "handlerOnFetch", response);
    setDebug(response.debug)

    const last = storageRequest.get();
    if (last && last.timestamp && isTimeout(last.timestamp)) {
      storageRequest.remove();
    } else if (last && last.request) {
      handlerOnSendOk(last.request, last);
      return;
    }

    if (response.status == "active") {
      const newLocation = response.fetchLocation;
      const currency = {
        ...newLocation.currency,
      };

      const store = getStoreData(newLocation,"STORE",strings);
      store.currency = currency;

      const newOrder = { ...order.current };
      newOrder.currency = currency;
      newOrder.priceDelivery = getDeliveryFees(store);
      newOrder.version = getTakeOrderVersion(newLocation.takeorder);
      newOrder.clientInfo = getCurrentClient(store.clientInfo);
      if(store.disableDelivery){
        newOrder.type = "takeaway"; 
      }

      let pickupPlace = undefined;
      if (!store.pickupService) {
        pickupPlace = {
          name: store.name,
          address: store.address,
          details: store.details,
          geopoint: store.geopoint,
        };
        //console.debug("App: handlerOnFetch, pickplace is storeData.address");
      }

      let targetPlace = undefined
      if (!store.pickupService) {
        const listAddress = addressDatasource.list();
        if (listAddress && listAddress.length > 0 && listAddress[0].geopoint && pickupPlace.geopoint) {
          const distance = getDistance(listAddress[0].geopoint, pickupPlace.geopoint);
          const maxDistance = store.maxDistance;
          //console.debug("App:handlerOnFetch, adding last target address");
          if (distance <= maxDistance)
            targetPlace = listAddress[0];
        }
      }

      newOrder.pickupAddress = pickupPlace;
      newOrder.fullAddress = targetPlace;

      order.current = newOrder;

      setFailure(null);
      setStoreData(store);
      setLocation(newLocation);
      setProgress(false);

      ////console.debug(" handlerOnFetch.location",newLocation);
      //console.debug(" handlerOnFetch.order",order.current);
      //console.debug(" handlerOnFetch.store",store);

      if (!response.screen) {
        //console.debug("App: handlerOnFetch show store");
        setStatus('store');

      } else {
        //console.debug("App: handlerOnFetch show test");
        setStatus('test');
      }

    } else if(response.status === "local"){

        const newLocation = response.fetchLocation;
        const currency = {
          ...newLocation.currency,
        };

        const store = getStoreData(newLocation,"LOCAL",strings);
        store.currency = currency;

        const newOrder = { ...order.current };
        newOrder.currency = currency;
        newOrder.version = getTakeOrderVersion(newLocation.takeorder);
        newOrder.clientInfo = getCurrentClient(store.clientInfo);
        newOrder.clientInfo.table = response.table; 
        newOrder.type = "AUTO"; 

        order.current = newOrder;

        setFailure(null);
        setStoreData(store);
        setLocation(newLocation);
        setProgress(false);
        setStatus('store');

    } else if (response.status === "qr") {
      const newLocation = response.fetchLocation;
      setFailure(null);
      setLocation(newLocation);
      setProgress(false);
      setStatus('qr');
    } else if (response.status === "ticket") {
      setFailure(null);
      setProgress(false);
      setStatus('ticket');
    } else {
      setProgress(false);
      setStatus('info');
      setFailure(response);
    }
  }

  /**
  ********************  When the user finish of select products. ******************************
  *********************************************************************************************/
  const handlerItemsSelected = (listOrder) => {
    if (storeData.pickupService) {
      handlerPickupServiceItemsSelected(listOrder);
    } else {
      handlerRestaurantItemsSelected(listOrder);
    }
  }

  const handlerRestaurantItemsSelected = (listOrder) => {
    //console.debug("App: handlerRestaurantItemsSelected");
    const newOrder = {
      ...order.current,
      list: listOrder,
    };

    //console.debug("App: handlerRestaurantItemsSelected, show Checkout");
    newOrder.status = 'checkout';
    order.current = newOrder;
    setStatus('checkout');
  }

  const handlerPickupServiceItemsSelected = (listOrder) => {
    //console.debug("App: handlerPickupServiceItemsSelected");
    const newOrder = {
      ...order.current,
      list: listOrder,
    };

    if (!newOrder.pickupAddress) {
      const listPickup = pickupDatasource.list();
      if (listPickup && listPickup.length > 0 && listPickup[0].geopoint) {
        newOrder.pickupAddress = listPickup[0];
      } else {
        newOrder.pickupAddress = undefined
        newOrder.status = 'pickup';
        order.current = newOrder;
        setStatus('pickup');
        return;
      }
    }

    if (!newOrder.fullAddress) {
      newOrder.fullAddress = undefined
      newOrder.status = 'address';
      order.current = newOrder;
      setStatus('address');
      return;
    }

    newOrder.status = 'checkout';
    order.current = newOrder;
    setStatus('checkout');

  }

  /**
   ******************************************** Pickup ******************************************
   **********************************************************************************************
   **/
  const handlerOnFinishPickup = (pickup) => {
    //console.debug("App: handlerOnFinishPickup");
    const newOrder = { ...order.current };
    newOrder.pickupAddress = pickup;
    order.current = newOrder;

    const targetGeopoint = order.current.fullAddress ? order.current.fullAddress.geopoint : undefined;

    if (targetGeopoint) {
      const delivery = getDeliveryFees(storeData, pickup.geopoint, targetGeopoint);
      newOrder.deliveryPrice = delivery;
      //console.debug("App: handlerOnFinishPickup, show CheckoutPage");
      setStatus('checkout');
    } else {
      //console.debug("App: handlerOnFinishPickup, show AddressPage");
      setStatus('address');
    }

  }

  const handlerOnCancelPickup = () => {
    //console.debug("handlerOnCancelPickup");
    setStatus('checkout');
  }
  const handlerNeedsPickup = (orderChecked) => {
    //console.debug(" handlerNeedsPickup: ",orderChecked);
    order.current = orderChecked;
    setStatus('pickup');
  }

  /************ EVENTS   target address ************************/
  const handlerOnFinishAddress = (fullAddress) => {
    //console.debug("App: handlerOnFinishAddress", fullAddress);  
    const newOrder = { ...order.current };
    const delivery = getDeliveryFees(storeData, fullAddress.geopoint);

    newOrder.fullAddress = fullAddress;
    newOrder.deliveryPrice = delivery;
    order.current = newOrder;
    //console.debug("App: handlerOnFinishAddressress order", order.current);
    setStatus('checkout');
  }

  const handlerOnEditAddress = () => {
    //console.debug("handlerOnEditAddress: ",order.current.fullAddress);
    setStatus('address');
  }

  const handlerOnEditPickup = () => {
    //console.debug("handlerOnEditPickup: ",order.current.pickupAddress);
    setStatus('pickup');
  }

  const handlerNeedsAddress = (orderChecked) => {
    //console.debug("App: handlerNeedsAddress",orderChecked);
    order.current = orderChecked;
    //console.debug("App: handlerNeedsAddress show AddressPage");
    setStatus('address');
  }

  const handlerOnCancelAddress = () => {
    setStatus('checkout');
  }

  /**
   * When the user is CHECKOUT and want avance 
   */
  const handlerOrderCheckoutOk = (orderChecked) => {
    order.current = orderChecked;
    if (storeData.requestClientInfo()) {
      setStatus('client');
    } else if (storeData.requestPaymentMethod()) {
      setStatus('payment');
    } else {
      //console.debug("App handlerOrderChecked show send");
      setStatus('send');
    }

  }

  const handlerBackFromCheckout = () => {

    const hasServices = hasItemServices(location);
    if (hasServices) {
      //console.debug("handlerBackFromCheckout With Item services");
      const newOrder = {
        ...order.current,
        list: removeServices(order.current.list),
      };
      order.current = newOrder;
    } else {
      console.debug("handlerBackFromCheckout, store:");
    }

    setStatus('store');
  }

  /** When the user  complete clientInfo  */

  const handlerOrderClientInfoOk = (orderClientInfo) => {
    order.current = orderClientInfo;
    const client = orderClientInfo.clientInfo;
    clientInfosource.set(client);

    if (storeData.requestPaymentMethod()) {
      setStatus('payment');
    } else {
      setStatus('send');
    }
  }

  const handlerOrderClientInfoBack = () => {
    ////console.debug("handlerOrderPaymentBack: ",orderChecked);

    setStatus('checkout');
  }



  /**
   *  When the user select the PAYMENT method  
   */
  const handlerOrderPaymentOK = (orderChecked) => {
    order.current = orderChecked;
    setStatus('send');
  }

  const handlerOrderPaymentBack = () => {
    if (storeData.requestClientInfo())
      setStatus('client')
    else setStatus('checkout');
  }

  /**
    *  When the user send the request
    */
  const handlerOnSendOk = (request, dataRequest) => {
    if (!request && !dataRequest) {
      return
    }
    let store = storeData;
    let initialRt;
    let newOrder;
    let isDebug = debug;
    let sentLink = order.current.type!=="AUTO";

    if (!dataRequest) {

      newOrder = {
        ...order.current,
        link: request.link,
        id: request.id,
        rtId: request.rtId,
      };

      initialRt = {
        link: request.link,
        id: request.id,
        rtId: request.rtId,
        status: "REQUEST",
        location: request.location
      };

      const requestData = {
        order: order.current,
        request: request,
        store: storeData,
        rtStatus: initialRt,
        debug: isDebug,
        timestamp: new Date().getTime(),
      }

      storageRequest.add(requestData);
      //console.debug("App: handlerOnSend first send");

    } else if (dataRequest) {
      setStoreData(dataRequest.store);
      store = dataRequest.store;
      newOrder = dataRequest.order;
      initialRt = dataRequest.rtStatus;
      request = dataRequest.request;
      isDebug = dataRequest.debug;
      sentLink = false;
      //console.debug("App: handlerOnSend recovering status");
    }

    order.current = newOrder;
    setRtStatus(initialRt);

    observeOrder(request, isDebug, (rtOrder) => {
      //console.debug("App: snapshot, rtOrder",rtOrder);
      if (rtOrder) {
        setRtStatus(rtOrder);
        const data = storageRequest.get();
        data.rtStatus.status = rtOrder.status;
        storageRequest.add(data);
       // console.debug("App: handlerOnSend observeOrder RT");
      }
    })

    if (sentLink) {
      const intent = getIntent(order.current, strings, store);
      const url = intent.replace('phone', store.phone)
      //console.debug("App: handlerOnSend intent:", url);
      window.open(url, '_blank');
    }

    setStatus('waiting');
    setProgress(false);
  }

  const handleOnSendBack = () => {
    if (storeData.requestPaymentMethod())
      setStatus('payment');
    else if (storeData.requestClientInfo()) {
      setStatus('client');
    } else {
      setStatus('checkout');
    }
  }

  const handlerOnReSend = () => {
    //console.debug("ReSent order: ",order.current);
    const intent = getIntent(order.current, strings, storeData);
    const phone = storeData.phone
    const url = intent.replace('phone', phone)
    window.open(url, '_blank');
    setStatus('waiting');
  }



  const handlerClickItemAdditions = (item) => {
    setItem(item);
    setStatus('item');
  }

  const handlerAddItemAdditions = (newList) => {
    //console.debug("handlerAddItemAdditions: ",newList);

    const newOrder = {
      ...order.current,
      list: newList,
    };

    order.current = newOrder;
    setStatus('store');
  }

  const handlerItemAdditionBack = () => {
    setStatus('store');
  }


  document.documentElement.lang = strings.meta_lang

  return (
    <ThemeProvider theme={theme}>

      {
        progress &&
        <Loading />
      }

      {
        status === 'fetch' &&
        <FetchLocation
          onFetch={handlerOnFetch}
        />
      }

      {location && status === 'qr' &&
        <StorePage
          location={location}
          setLocation={setLocation}
          strings={strings}
          onCheckout={handlerItemsSelected}
          isTakingOrder={false}
        />
      }

      {location && status === 'store' &&
        <StorePage
          location={location}
          setLocation={setLocation}
          strings={strings}
          order={order.current}
          onCheckout={handlerItemsSelected}
          isTakingOrder={true}
          onOrderAddItemAdditions={handlerClickItemAdditions}
        />
      }
      {item && status === 'item' &&
        <ItemPage
          strings={strings}
          order={order.current}
          showCurrency={location.current.content.showCurrency}
          store={storeData}
          onBack={handlerItemAdditionBack}
          item={item}
          onAddItemAdditions={handlerAddItemAdditions}
        />

      }

      { order.current && storeData && status === 'checkout' &&
        <CheckoutPage
          store={storeData}
          order={order.current}
          onOrderChecked={handlerOrderCheckoutOk}
          onNeedsAddress={handlerNeedsAddress}
          onNeedsPickup={handlerNeedsPickup}
          onBack={handlerBackFromCheckout}
          onEditPickup={handlerOnEditPickup}
          onEditAddress={handlerOnEditAddress}
          strings={strings}
        />
      }

      {status === 'address' &&
        <AddressPage
          strings={strings}
          title={strings.delivery_address}
          onCancel={handlerOnCancelAddress}
          onFinish={handlerOnFinishAddress}
          store={storeData}
          dataSource={addressDatasource}
          defaultAddress={undefined}
          defaultPickup={order.current.pickupAddress}
          type={status}
        />
      }

      {status === 'pickup' &&
        <AddressPage
          strings={strings}
          onCancel={handlerOnCancelPickup}
          onFinish={handlerOnFinishPickup}
          store={storeData}
          title={strings.pickup_address}
          dataSource={pickupDatasource}
          defaultAddress={undefined}
          defaultPickup={order.current.pickupAddress}
          type={status}
        />
      }

      {status === 'client' &&
        <ClientInfoPage
          store={storeData}
          strings={strings}
          order={order.current}
          onBack={handlerOrderClientInfoBack}
          onNext={handlerOrderClientInfoOk}
        />
      }

      {status === 'payment' &&
        <PaymentPage
          store={storeData}
          strings={strings}
          order={order.current}
          onBack={handlerOrderPaymentBack}
          onNext={handlerOrderPaymentOK}
        />
      }


      {status === 'send' &&
        <SendPage
          store={storeData}
          strings={strings}
          order={order.current}
          onBack={handleOnSendBack}
          onSend={handlerOnSendOk}
          debug={debug}
        />
      }
      {status === 'waiting' &&

        <OrderStatus
          strings={strings}
          store={storeData}
          order={order.current}
          orderRt={rtStatus}
          onBack={() => {
            resetStore();
          }}
          onSend={handlerOnReSend}
        />
      }
      {status === 'info' && failure &&
        <InfoPage
          failure={failure}
          strings={strings}
        />
      }
      {status === 'test' &&
        <ClientInfoPage
          store={storeData}
          strings={strings}
          order={order.current}
          onBack={handlerOrderPaymentBack}
          onNext={handlerOrderPaymentOK}
        />

      }
      {status === 'ticket' &&
        <OpenTicketPage
          strings={strings}
        />
      }

    </ThemeProvider>
  );
}